import { createContext, useContext, useState } from "react";
import { translations } from "../data/content";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("hi");
  const value = {
    lang,
    setLang,
    toggle: () => setLang((l) => (l === "hi" ? "en" : "hi")),
    t: translations[lang],
  };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
